import { Injectable, inject } from '@angular/core';

// Services
import { LoggerService } from '../logger/logger.service';

@Injectable({ providedIn: 'root' })
export class WsErrorService {
  private logger = inject(LoggerService);

  public webServiceError: boolean;
  public webServiceLabelError: string | undefined;
  public isLoadingMp3: boolean = false;
  public noButtonsToShow: boolean;
  public needToTranslate: boolean;

  setWebServiceError(
    label: string,
    noButtons: boolean = false,
    isLoadingMp3: boolean = false,
    needToTranslate: boolean = true,
  ): void {
    this.logger.consoleLog('WebServiceErrorUtils', 'setWebServiceError', { label, noButtons, isLoadingMp3 });

    this.webServiceLabelError = label;
    this.webServiceError = true;
    this.noButtonsToShow = noButtons;
    this.isLoadingMp3 = isLoadingMp3;
    this.needToTranslate = needToTranslate;
  }

  removeWebServiceError(toForce?: boolean): void {
    this.logger.consoleLog('WebServiceErrorUtils', 'removeWebServiceError', {
      toForce,
      willClear: !this.isLoadingMp3 || toForce !== undefined,
    });

    if (!this.isLoadingMp3 || toForce !== undefined) {
      this.webServiceLabelError = undefined;
      this.webServiceError = false;
      this.noButtonsToShow = false;
    }
  }
}
